import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { i18nextPlugin } from 'translation-check';
import navigatorDetector from './browserLookups/navigator';
const languageDetector = new LanguageDetector();
languageDetector.addDetector(navigatorDetector);

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(languageDetector)
  .use(i18nextPlugin)

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    detection: {
      order: ['navigator'],
    },
    ns: ['homepage', 'common', 'cart', 'delivery', 'checkout'],
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    // translationStats: {
    //   // optional options, if not provided it will guess based on your i18next config
    //   queryStringParam: 'showtranslations',
    //   sourceLng: 'ru',
    //   targetLngs: ['en'],
    //   preserveEmptyStrings: false
    // }
  });

export default i18n;
